import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useAppointments } from "@/app/pmc/appointments/appointments.hooks";
import { useProperties } from "@/app/pmc/properties/properties.hooks";
import BookingSheet from "@/app/pmc/appointments/components/BookingSheet";
import BulkUploadModal from "@/app/pmc/appointments/components/BulkUploadModal";
import { PropertyModal } from "@/app/pmc/properties/properties.components/property-modal";

export default function QuickActions() {
  const { openSheet, sheetOpen, closeSheet, refetch: refetchAppointments } = useAppointments();
  const { openCreateModal, closeCreateModal, handleCreate, creating } = useProperties();
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);

  const handleBookAppointment = () => {
    openSheet();
  };

  const handleBulkUpload = () => {
    setBulkUploadOpen(true);
  };

  const handleAddProperty = () => {
    openCreateModal();
  };

  return (
    <>
      <div className="flex justify-start items-center gap-2">
        <span className="text-sm uppercase mr-8">Quick Actions:</span>
        <Button variant="default" className="uppercase" size="lg" onClick={handleBookAppointment}>
          Book an Appointment
        </Button>
        <Button variant="outline" className="uppercase" size="lg" onClick={handleBulkUpload}>
          Bulk Upload Appointments
        </Button>
        <Button variant="outline" className="uppercase" size="lg" onClick={handleAddProperty}>
          Add New Property
        </Button>
      </div>

      {sheetOpen && <BookingSheet />}

      {bulkUploadOpen && (
        <BulkUploadModal
          isOpen={bulkUploadOpen}
          onClose={() => setBulkUploadOpen(false)}
          onUploadComplete={() => {
            refetchAppointments();
            setBulkUploadOpen(false);
          }}
        />
      )}

      {creating && <PropertyModal open={creating} onOpenChange={closeCreateModal} onSubmit={handleCreate} />}
    </>
  );
}
